import {STATE_DATA, MISC_PARTICULAR, MISC_TOTALS, CLEAR_MISC, CLEAR_TEMP_MISC, CHANGE_FY, MISC_LOCALS, FY_LIST,
  INVPUR_LIST, INVPUR_TOTAL
} from '../../Helper/actionsTypes';

const miscReducer =(state={
  particular: [],
  totals: {
    tat: 0,
    qty: 0,
    gst: 0,
    cess: 0,
    base: 0,
    amount: 0,
    totalTax: 0,
    taxable: 0,
    discount: 0,
    cessTaxable: 0,
    taxDetails: [],
    cessDetails: [],
  },
  local: {input: false,},
  piTotal: {
    balance: 0,
    amount: 0
  },
  piList:[]
}, action) => {
  switch (action.type) {
    case MISC_LOCALS:
      return {...state, local: action.payload};
    case STATE_DATA:
      return {...state, stateObj: action.payload};
    case MISC_PARTICULAR:
      return {...state, particular: action.payload};
    case MISC_TOTALS:
      return {...state, totals: action.payload};
    case FY_LIST:
      return action.error
        ? {...state, fyList: []}
        : {...state, fyList: action.payload};
    case INVPUR_LIST:
      return {...state, piList: action.payload};
    case INVPUR_TOTAL:
      return {...state, piTotal: action.payload};
    case CHANGE_FY:
      return action.error
        ? {...state, itemFy: false}
        : {...state, itemFy: true};
    case CLEAR_TEMP_MISC:
      return {
        ...state, itemFy: null
      };
    case CLEAR_MISC:
      return {
        particular: [],
        totals: {
          tat: 0,
          qty: 0,
          gst: 0,
          cess: 0,
          base: 0,
          amount     : 0,
          totalTax   : 0,
          taxable    : 0,
          discount   : 0,
          cessTaxable: 0,
          taxDetails : [],
          cessDetails: [],
        },
        local: {input: false,},
        piTotal: {
          balance: 0,
          amount: 0
        },
        piList:[]
      };
      case 'CLEAR_PERTICULARS':
      return {
        particular: [],
        totals: {
          tat: 0,
          qty: 0,
          gst: 0,
          cess: 0,
          base: 0,
          amount: 0,
          totalTax: 0,
          taxable: 0,
          discount: 0,
          cessTaxable: 0,
          taxDetails: [],
          cessDetails: [],
        },
        local: {input: false,},
        piTotal: {
          balance: 0,
          amount: 0
        },
        piList:[]
      }
    default: return state;
  }
};
export default miscReducer;
